module.exports = __webpack_public_path__ + "static/1-363bd1e30c5a461ec041fd7c1d9e1e77.jpg";